// extracted by mini-css-extract-plugin
module.exports = {"homePhoto":"index-module--home-photo--3bKr7"};